<template>
  <div class="favorite-menu">
    <dl class="favorite-list" v-for="intranetInfo in intranetList" :key="intranetInfo.no">
      <dt class="favorite-term">{{ intranetInfo.name }}</dt>
      <dd
        class="favorite-desc"
        v-for="bookmarkIntranetInfo in intranetInfo.bookmark_categories"
        :key="bookmarkIntranetInfo.no"
      >
        <button
          type="button"
          title="즐겨찾기"
          class="favorite-star"
          @click="
            setIntranetVisible(bookmarkIntranetInfo.no, bookmarkIntranetInfo.bookmark_user_config.is_visible !== 'Y')
          "
        >
          <i class="gi-star" :class="bookmarkIntranetInfo.bookmark_user_config.is_visible === 'Y' ? 'gis' : 'gi'"></i>
        </button>
        <a
          @click="clickIntranet(bookmarkIntranetInfo.bookmark)"
          target="_blank"
          class="favorite-link officehome-menu-work-edit"
        >
          {{ bookmarkIntranetInfo.bookmark.name }}
        </a>
      </dd>
    </dl>
    <dl class="favorite-list" v-if="isV3 && noCategoryIntranetList.length" key="no-category-intranet">
      <dt class="favorite-term">{{ $t('카테고리 미지정') }}</dt>
      <dd class="favorite-desc" v-for="bookmarkIntranetInfo in noCategoryIntranetList" :key="bookmarkIntranetInfo.no">
        <button
          type="button"
          title="즐겨찾기"
          class="favorite-star"
          @click="
            setNoCategoryIntranetVisible(
              bookmarkIntranetInfo.no,
              bookmarkIntranetInfo.bookmark_user_config.is_visible !== 'Y',
            )
          "
        >
          <i class="gi-star" :class="bookmarkIntranetInfo.bookmark_user_config.is_visible === 'Y' ? 'gis' : 'gi'"></i>
        </button>
        <a @click="clickIntranet(bookmarkIntranetInfo.bookmark)" class="favorite-link officehome-menu-work">{{
          bookmarkIntranetInfo.bookmark.name
        }}</a>
      </dd>
    </dl>

    <dl class="favorite-list" v-show="myPlusAppList.length > 0">
      <dt class="favorite-term">{{ $t('PLUS_LINK') }}</dt>
      <dd class="favorite-desc" v-for="myPlusApp in myPlusAppList" :key="myPlusApp.id">
        <button
          type="button"
          title="즐겨찾기"
          class="favorite-star"
          @click="setMyPlusAppVisible(myPlusApp.id, myPlusApp.star)"
        >
          <i class="gi-star" :class="myPlusApp.star ? 'gis' : 'gi'"></i>
        </button>
        <div class="favorite-link officehome-menu-plusapp-edit" @click="clickPlusApp(myPlusApp)">
          {{ myPlusApp.office_app.app_name }}
        </div>
      </dd>
    </dl>

    <dl class="favorite-list" v-show="groupList.length > 0">
      <dt class="favorite-term">{{ $t('GROUP_LINK') }}</dt>
      <dd class="favorite-desc" v-for="groupInfo in groupList" :key="groupInfo.id">
        <button
          type="button"
          title="즐겨찾기"
          class="favorite-star"
          @click="setGroupVisible(groupInfo.id, groupInfo.starred)"
        >
          <i class="gi-star" :class="groupInfo.starred ? 'gis' : 'gi'"></i>
        </button>
        <a :href="getGroupLink(groupInfo.id)" class="favorite-link officehome-menu-group-edit">{{ groupInfo.title }}</a>
      </dd>
    </dl>

    <dl class="favorite-list">
      <dt class="favorite-term">
        {{ $t('MY_FAVORITE') }}
        <i class="fas fa-plus bookmark-btn" @click="showBookmarkOrderSetting"></i>
      </dt>
      <dd class="favorite-desc" v-for="bookmarkInfo in bookmarkList" :key="bookmarkInfo.no">
        <button
          type="button"
          title="즐겨찾기"
          class="favorite-star"
          @click="setBookmarkVisible(bookmarkInfo.no, bookmarkInfo.bookmark_user_config.is_visible !== 'Y')"
        >
          <i class="gi-star" :class="bookmarkInfo.bookmark_user_config.is_visible === 'Y' ? 'gis' : 'gi'"> </i>
        </button>
        <a :href="getHttpUrl(bookmarkInfo.bookmark.url)" target="_blank" class="favorite-link">{{
          bookmarkInfo.bookmark.name
        }}</a>
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MenuDetailRight',
  props: {
    intranetList: {
      type: Array,
      required: true,
    },
    bookmarkList: {
      type: Array,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    myPlusAppList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isV3: 'cache/isV3',
    }),
    ...mapState({
      noCategoryIntranetList: (state) => state.bookmark.noCategoryIntranetList,
    }),
    check() {
      console.log('check', this.noCategoryIntranetList);
      return this.noCategoryIntranetList;
    },
    isVisibleIntranetList() {
      let intranetList = [];

      this.intranetList.forEach((intranetInfo) => {
        if (intranetInfo.bookmark_categories !== null || intranetInfo.bookmark_categories.length > 0) {
          let targetIntranetInfo = Object.assign({}, intranetInfo);
          targetIntranetInfo.bookmark_categories = [];

          intranetInfo.bookmark_categories.forEach((childIntranetInfo) => {
            if (
              childIntranetInfo.bookmark_user_config === null ||
              childIntranetInfo.bookmark_user_config.is_visible === 'Y'
            ) {
              targetIntranetInfo.bookmark_categories.push(childIntranetInfo);
            }
          });

          if (targetIntranetInfo.bookmark_categories.length > 0) {
            intranetList.push(targetIntranetInfo);
          }
        }
      });

      return intranetList;
    },
    isVisibleGroupList() {
      let groupList = [];

      this.groupList.forEach((groupInfo) => {
        if (groupInfo.starred) {
          groupList.push(groupInfo);
        }
      });

      return groupList;
    },
    isVisibleBookmarkList() {
      let bookmarkList = [];

      this.bookmarkList.forEach((bookmarkInfo) => {
        if (bookmarkInfo.bookmark_categories !== null || bookmarkInfo.bookmark_categories.length > 0) {
          if (bookmarkInfo.bookmark_user_config === null || bookmarkInfo.bookmark_user_config.is_visible === 'Y') {
            bookmarkList.push(bookmarkInfo);
          }
        }
      });

      return bookmarkList;
    },
  },
  methods: {
    showBookmarkOrderSetting() {
      this.$emit('show-bookmark-order-setting');
    },
    getHttpUrl(url) {
      let urlPattern = /^(http|https):/;
      return urlPattern.test(url) ? url : 'http://' + url;
    },
    getGroupLink(id) {
      return process.env.VUE_APP_OFFICE_GROUP_URL + '/group/' + id + '/debates/all';
    },
    setIntranetVisible(bookmarkCategoriesNo, isVisible) {
      this.$emit('set-intranet-visible', bookmarkCategoriesNo, isVisible);
    },
    setNoCategoryIntranetVisible(bookmarkCategoriesNo, isVisible) {
      this.$store.dispatch('bookmark/setNoCategoryIntranetVisible', { bookmarkCategoriesNo, isVisible });
    },

    setBookmarkVisible(bookmarkCategoriesNo, isVisible) {
      this.$emit('set-bookmark-visible', bookmarkCategoriesNo, isVisible);
    },
    setGroupVisible(groupId, isVisible) {
      this.$emit('set-group-visible', groupId, !isVisible);
    },
    setMyPlusAppVisible(id, star) {
      this.$emit('set-my-plus-app-visible', id, !star);
    },
    clickPlusApp(myPlusApp) {
      this.$emit('click-plus-app', myPlusApp);
    },
    clickIntranet(bookmark) {
      this.$emit('click-intranet', bookmark);
    },
  },
};
</script>

<style lang="scss" scoped>
.favorite-menu {
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding: 24px 20px 20px 20px;
  box-sizing: border-box;
  @media (min-width: 900px) {
    max-width: 213px;
    min-width: 213px;
    max-height: 610px;
    padding: 0 10px;
    margin-bottom: 23px;
  }
  .favorite-list {
    margin-bottom: 14px;
    .favorite-term {
      font-size: 12px;
      color: #909090;
      margin-bottom: 5px;
      @media (min-width: 900px) {
        padding-left: 20px;
      }
      .bookmark-btn {
        cursor: pointer;
      }
    }
    .favorite-desc {
      display: flex;
      align-items: center;
      padding: 0 8px;
      height: 40px;
      @media (min-width: 900px) {
        padding: 0 20px;
        height: 32px;
      }
      &:hover {
        background: #eff4fc;
        cursor: pointer;
        .favorite-link {
          color: #2985db;
        }
      }
      .favorite-star {
        color: #fdc036;
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        outline: 0;
        i {
          font-size: 14px;
        }
        .gi {
          color: #aeaeae;
        }
        &:hover {
          .gi {
            color: #fdc036;
          }
          .gis {
            color: #fdc036;
          }
        }
      }
      .favorite-link {
        display: block;
        width: 100%;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        padding-left: 4px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
